<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addShipOnlyModal"
        persistent
        max-width="800px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">
                  {{ isUpdate ? $t('orders.updateShipOnlyTitle') : $t('orders.newShipOnlyTitle') }}
                </span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="isDone"
              >
                {{ isUpdate ? $t('common.updatedSuccessfully') : $t('orders.orderedSuccessfully') }}
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <branch-select
                    :disabled="isUpdate"
                    v-model="form.branch_id_fk"
                  />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="loggedInUserData.is_staff"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    item-value="value"
                    v-model="form.customer_id_fk"
                    :error-messages="errors.collect('customer_id_fk')"
                    data-vv-name="customer_id_fk"
                    :label="$t('columns.customer') + '*'"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.productName') + '*'"
                    v-model="form.product_name"
                    :error-messages="errors.collect('product_name')"
                    v-validate="'required'"
                    data-vv-name="product_name"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.productUrl')"
                    v-model="form.product_url"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.quantity')"
                    v-model="form.quantity"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="form.warehouse_id_fk"
                    :error-messages="errors.collect('warehouse_id_fk')"
                    data-vv-name="warehouse_id_fk"
                    :label="$t('columns.warehouse') + '*'"
                    v-validate="'required'"
                    @input="handleSelectWarehouse(form.warehouse_id_fk)"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="transportationTypes"
                    item-value="id"
                    item-text="name"
                    v-model="form.transportation_type"
                    :error-messages="errors.collect('Transportation Type')"
                    data-vv-name="Transportation Type"
                    :label="$t('columns.transportationType') + '*'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.weight')"
                    v-model="form.item_weight"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.volume')"
                    v-model="form.volume"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.trackNumber')"
                    v-model="form.track_number"
                    data-vv-name="Track Number"
                    :error-messages="errors.collect('Track Number')"
                    v-validate="isUpdate ? 'required' : ''"
                    @input="removeSpaces()"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                >
                  <v-text-field
                    :label="$t('columns.shipping')"
                    v-model.number="form.internal_shipping_handling"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Shipping')"
                    v-validate="'decimal:2'"
                    data-vv-name="Shipping"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                >
                  <v-text-field
                    :label="$t('columns.tax')"
                    v-model.number="form.tax"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Tax')"
                    v-validate="'decimal:2'"
                    data-vv-name="Tax"
                  />
                </v-flex>

                <v-flex
                  class="px-2 mb-2"
                  xs12
                  sm12
                  md6
                >
                  <date-picker
                    style="border-bottom-color: #919191"
                    :date="startTime"
                    :option="option"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="fromDateError"
                    style="color: orangered"
                  ><br />{{ $t('orders.fromDateGreaterThanTodayError') }}</span>
                </v-flex>

                <v-flex
                  class="px-2 mb-2"
                  xs12
                  sm12
                  md6
                >
                  <date-picker
                    style="border-bottom-color: #919191"
                    :date="startTime1"
                    :option="option1"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="toDateError"
                    style="color: orangered"
                  ><br />{{ $t('orders.toDateGreaterThanFromDateError') }}</span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                >
                  <v-text-field
                    :label="$t('columns.note')"
                    v-model="form.note"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm3
                >
                  <v-checkbox
                    :label="$t('customer.repackage')"
                    v-model="form.is_repackage"
                    class="ma-0 pa-0 mt-4"
                    hide-details
                    @change="repackageChanged()"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm2
                >
                  <v-checkbox
                    :label="$t('delivery.holdStatus')"
                    v-model="form.is_hold"
                    class="ma-0 pa-0 mt-4"
                    hide-details
                    @change="holdChanged()"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  md7
                >
                  <v-text-field
                    :label="$t('orders.otherServiceSpecifyLabel')"
                    v-model="form.other_service"
                    data-vv-name="other_service"
                    @input="otherServiceChanged()"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('customer.repackagePrice')"
                    v-model.number="form.repackage_price"
                    :disabled="!form.is_repackage"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Repackage Price')"
                    v-validate="'decimal:2'"
                    data-vv-name="Repackage Price"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('customer.holdPrice')"
                    v-model.number="form.hold_price"
                    :disabled="!form.is_hold"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Hold Price')"
                    v-validate="'decimal:2'"
                    data-vv-name="Hold Price"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('customer.otherServicePrice')"
                    v-model.number="form.other_service_price"
                    :disabled="!form.other_service || !form.other_service.length"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Other Service Price')"
                    v-validate="'decimal:2'"
                    data-vv-name="Other Service Price"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('invoice.handlingFeeLabel')"
                    v-model="form.handling_fee"
                    data-vv-name="handling_fee"
                    @input="calculateTotalAmount()"
                  >
                  </v-text-field>
                </v-flex>

              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import myDatepicker from 'vue-datepicker'

export default {
  created() {
    this.getLoggedInUser()
  },

  components: {
    'date-picker': myDatepicker
  },

  props: [
    'addShipOnlyModal',
    'warehouses',
    'closeAddNewOrderModal',
    'customers',
    'checkURL',
    'isUpdate',
    'formData',
  ],

  data() {
    return {
      transportationTypes: [],
      loggedInUserData: {},
      loading: false,
      form: {
        transportation_type: null
      },
      isDone: false,
      fromDateError: false,
      toDateError: false,
      startTime: {},
      startTime1: {},
      today: null,
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5',
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5',
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD HH:mm',
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD HH:mm',
      },
    }
  },

  watch: {
    addShipOnlyModal: {
      immediate: false,
      handler() {
        if (this.addShipOnlyModal) {
          let t = new Date()
          let dd = t.getDate()
          let mm = t.getMonth() + 1 // January is 0!
          let yyyy = t.getFullYear()

          if (dd < 10) {
            dd = '0' + dd
          }

          if (mm < 10) {
            mm = '0' + mm
          }

          t = yyyy + '-' + mm + '-' + dd
          this.today = t

          if (this.isUpdate) {
            this.form = this.formData

            const warehouse = this.warehouses.find(w => w.value === this.formData.warehouse_id_fk)

            if (warehouse) {
              this.transportationTypes = warehouse.transportation_types
            }

            const estimateDays = (warehouse && warehouse.estimate_days && Number(warehouse.estimate_days) > 0)
              ? Number(warehouse.estimate_days)
              : 7
            const fmt = (date) => {
              const dd = String(date.getDate()).padStart(2, '0')
              const mm = String(date.getMonth() + 1).padStart(2, '0')
              return `${date.getFullYear()}-${mm}-${dd}`
            }
            const fromDate = new Date()
            fromDate.setDate(fromDate.getDate() + 1)
            const toDate = new Date(fromDate)
            toDate.setDate(toDate.getDate() + estimateDays)
            this.startTime = { ...this.startTime, time: fmt(fromDate) }
            this.startTime1 = { ...this.startTime1, time: fmt(toDate) }
          } else {
            this.startTime = { ...this.startTime, time: t }
            this.startTime1 = { ...this.startTime1, time: t }
          }
        }
      }
    }
  },

  methods: {
    repackageChanged() {
      if (!this.form.is_repackage) {
        this.form.repackage_price = 0
      }
      this.calculateTotalAmount()
    },

    holdChanged() {
      if (!this.form.is_hold) {
        this.form.hold_price = 0
      }
      this.calculateTotalAmount()
    },

    otherServiceChanged() {
      if (!this.form.other_service) {
        this.form.other_service_price = 0
      }
      this.calculateTotalAmount()
    },

    handleSelectWarehouse(id) {
      this.form.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }

      const estimateDays = (warehouse && warehouse.estimate_days && Number(warehouse.estimate_days) > 0)
        ? Number(warehouse.estimate_days)
        : 7
      const fmt = (date) => {
        const dd = String(date.getDate()).padStart(2, '0')
        const mm = String(date.getMonth() + 1).padStart(2, '0')
        return `${date.getFullYear()}-${mm}-${dd}`
      }
      const fromDate = new Date()
      fromDate.setDate(fromDate.getDate() + 1)
      const toDate = new Date(fromDate)
      toDate.setDate(toDate.getDate() + estimateDays)
      this.startTime = { ...this.startTime, time: fmt(fromDate) }
      this.startTime1 = { ...this.startTime1, time: fmt(toDate) }
    },

    removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '')
    },

    closeDialog() {
      this.$validator.reset()
      this.form = {}
      this.$emit('close')
    },

    calculateTotalAmount() {
      let shipping = this.form.internal_shipping_handling ? this.form.internal_shipping_handling : 0
      let tax = this.form.tax ? this.form.tax : 0
      let repackage = this.form.repackage_price ? this.form.repackage_price : 0
      let hold = this.form.hold_price ? this.form.hold_price : 0
      let otherService = this.form.other_service_price ? this.form.other_service_price : 0
      let handlingFee = this.form.handling_fee ? this.form.handling_fee : 0

      this.form.total_amount = Number(shipping) + Number(tax) + Number(repackage) + Number(hold) + Number(otherService) + Number(handlingFee)
      this.form.total_amount = Number(this.form.total_amount.toFixed(2))
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.startTime && this.startTime.time <= this.today) {
            this.toDateError = false
            this.fromDateError = true
            return
          }

          if (this.startTime1 && this.startTime && this.startTime1.time <= this.startTime.time) {
            this.fromDateError = false
            this.toDateError = true
            return
          }

          this.form.from_date = this.startTime.time
          this.form.to_date = this.startTime1.time

          if (this.isUpdate) {
            Axios.put(`api/update_ship_only_order/${this.form.order_id}`, this.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(() => {
              this.isDone = true
              this.startTime = {}
              this.startTime1 = {}
              this.form = {}
              this.toDateError = false
              this.fromDateError = false
              setTimeout(() => {
                this.isDone = false
                this.$emit('resetTable')
                this.$emit('close')
              }, 2000)
            })
          } else {
            Axios.post('api/store_ship_only_order', this.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(res => {
              this.isDone = true
              this.startTime = {}
              this.startTime1 = {}
              this.form = {}
              this.toDateError = false
              this.fromDateError = false
              setTimeout(() => {
                this.isDone = false
                this.$emit('resetTable', res.data)
                this.$emit('close')
              }, 2000)
            })
          }
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addShipOnly.vue